import React, { useState } from "react";
import CourierVendors from "components/ShippingDetails/CourierVendors";
import Button from "components/Button";
import ShippingCost from "components/ShippingDetails/ShippingCost";
import USAFlag from "assets/images/usa-flag.png";
import CADFlag from "assets/images/canada-flag.png";
import AUFlag from "assets/images/aus-flag.jpeg";
import EUFlag from "assets/images/eu-flag.png";
import {
  State,
  ButtonStyles,
  FlagStyles,
  activeButtonStyles,
} from "styles/components/ShippingDetails";

const ShippingDetails = ({ data }) => {
  const [selectedPrintProvider, setPrintProvider] = useState(undefined);
  const [selectedVendor, setVendor] = useState(undefined);
  const { PrintProviders } = data;

  return (
    <>
      <h3>Select Fulfillment Plant</h3>

      <State>
        {PrintProviders?.map((printProvider, index) => (
          <Button
            key={`printProvider${index}`}
            containerStyle={
              selectedPrintProvider?.ProviderName ===
              printProvider?.ProviderName
                ? {
                    ...ButtonStyles,
                    ...activeButtonStyles,
                  }
                : ButtonStyles
            }
            variant="text"
            title={`${printProvider.ProviderName} Fulfillment Plant`}
            onClick={() => {
              setPrintProvider(printProvider);
              setVendor(undefined);
            }}
            startIcon={
              <img
                src={
                  printProvider?.ProviderName === "CA"
                    ? CADFlag
                    : printProvider?.ProviderName === "US"
                    ? USAFlag
                    : printProvider?.ProviderName === "EU"
                    ? EUFlag
                    : AUFlag
                }
                alt="ProviderFlag"
                style={FlagStyles}
              />
            }
          />
        ))}
      </State>
      {selectedPrintProvider && (
        <>
          <h3>Select Destination Country</h3>
          <CourierVendors
            vendors={selectedPrintProvider?.ShippingCosts}
            selectedVendor={selectedVendor}
            setVendor={(v) => setVendor(v)}
          />
        </>
      )}
      {selectedVendor && (
        <ShippingCost cost={selectedVendor} selectedVendor={selectedVendor} />
      )}
    </>
  );
};

export default ShippingDetails;
